import { Action, createReducer, on } from '@ngrx/store';
import { AppSpecificDataState } from '@customer-apps/shared/interfaces';
import { AppSpecificDataActions } from './app-specific-data.actions';
import { CalculationMethodDictionary } from '@customer-apps/shared/utils';
import { LodashService } from '@customer-apps/shared/services';

import data from '../../../../../../package.json';

export const initialAppSpecificDataState: AppSpecificDataState = {
    viguidePlanningSpecificData: {
        apiVersion: '',
        applicationVersion: '',
        heatLoadCalculationsData: {}
    }
};

const reducer = createReducer(
    initialAppSpecificDataState,
    on(AppSpecificDataActions.setAppSpecificData, (state, { viguidePlanningSpecificData }) => {
        return {
            viguidePlanningSpecificData: {
                ...viguidePlanningSpecificData,
                applicationVersion: viguidePlanningSpecificData.applicationVersion || data.version
            }
        };
    }),
    on(AppSpecificDataActions.addHeatloadCalculation, (state, { method, calculation }) => {
        return {
            ...state,
            viguidePlanningSpecificData: {
                ...state.viguidePlanningSpecificData,
                heatLoadCalculationsData: {
                    ...state.viguidePlanningSpecificData.heatLoadCalculationsData,
                    [CalculationMethodDictionary[method]]: { ...calculation, method }
                }
            }
        };
    }),
    on(AppSpecificDataActions.removeHeatloadCalculation, (state, { method }) => {
        return {
            ...state,
            viguidePlanningSpecificData: {
                ...state.viguidePlanningSpecificData,
                heatLoadCalculationsData: LodashService.omit(
                    state.viguidePlanningSpecificData.heatLoadCalculationsData,
                    CalculationMethodDictionary[method]
                )
            }
        };
    }),
    on(AppSpecificDataActions.removeAllHeatloadCalculations, state => ({
        ...state,
        viguidePlanningSpecificData: {
            ...state.viguidePlanningSpecificData,
            heatLoadCalculationsData: {}
        }
    }))
);

export function appSpecificDataReducer(state: AppSpecificDataState | undefined, action: Action) {
    return reducer(state, action);
}
